module.exports = __webpack_public_path__ + "static/img/rec_edges_r_t.a88b10fd.png";